export enum BreadCrumbLabel {

  url = 'url',
  browse = 'browse',
  search = 'search',
  work = 'work',
  work_work = 'work_work',
  work_materialization = 'work_materialization',
  museum_object = 'museum_object',
  archive_object = 'archive_object',
  materialization = 'materialization',
  descriptor_object = 'descriptor_object',
  info_page = 'info_page',
  account = 'account',
  collectionId = 'collectionId',
  collections = 'collections',
  queries = 'queries',
  institutions = 'institutions',
  sitemap = 'sitemap',
  sparql = 'sparql',
  login = 'login'
}
